module.exports = __webpack_public_path__ + "static/susan-j-fowler-0e8ddd89f4cf2bbf7a8c0f21301a0da1.jpg";